import React from 'react';
import {useNavigate} from "react-router-dom"

import {
  LockOutlined,
} from '@ant-design/icons';

import {
  Layout, 
  Watermark,  
  Input, 
  Button, 
  Form, 
  Card,
  message
} from 'antd';

import { PW } from './config';


const Login: React.FC = () => {
  
  const navigate = useNavigate()
 
  const [myForm] = Form.useForm()

  const onSubmit = () => {
    if (myForm.getFieldValue("login_password") === PW){
      navigate("/app/home")
      localStorage.setItem("token", PW)
    }else{
      message.error("访问密码错误")
    }
  };


  return (
      <Layout style={{ height: '100vh' }}>
          <Watermark content="DOC">
          <div style={{display: 'flex', height: '100vh', alignItems: 'stretch'}}>
            <div style={{width:"340px", margin:"200px auto"}}>
              <Card title="DOC LOGIN" bordered={false} style={{ width: "100%" }}>
                <Form form={myForm} onKeyPress={(e)=>{e.key==="Enter" && onSubmit()}} >
                    <Form.Item name="login_password" >
                      <Input.Password size='large' placeholder="登录密码" prefix={<LockOutlined style={{marginRight:'10px'}}/>} />
                    </Form.Item>  
                    <Button type="primary" onClick={onSubmit} size='large' block>登录</Button>
                </Form>
              </Card>
            </div>
          </div>
          </Watermark>
      </Layout>
  )
}
export default Login